import { MutationCache, QueryClient } from '@tanstack/vue-query'
import { GET_PROJECTS, SET_PROJECT } from '@/services/apiModules'

export function createQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
    mutationCache: new MutationCache({
      onSuccess: (_data, _variables, _onMutateResult, mutation) => {
        // Whenever a set project is called:
        if (mutation.options.mutationKey?.[0] === SET_PROJECT) {
          // Resets all project-related queries except for the GET_PROJECTS query.
          queryClient.resetQueries({
            predicate: (query) => query.queryKey[0] !== GET_PROJECTS,
          })
        }
      },
    }),
  })

  return queryClient
}
